/**
 * Collection Tabs Section JavaScript with Swiper Integration
 * Handles desktop and mobile tab functionality, Swiper sliders, and variant swatches
 */

let swiperInstances = {};

document.addEventListener('DOMContentLoaded', function() {
  // Wait for Swiper to be available
  if (typeof Swiper !== 'undefined') {
    initDesktopTabs();
    initSwiperSliders();
    initVariantSwatches();
    initMobileTabs();
    initMobileProducts();
    initMobileVariantSwatches();
  } else {
    // Retry after a short delay if Swiper isn't loaded yet
    setTimeout(function() {
      if (typeof Swiper !== 'undefined') {
        initDesktopTabs();
        initSwiperSliders();
        initVariantSwatches();
        initMobileTabs();
        initMobileProducts();
        initMobileVariantSwatches();
      }
    }, 100);
  }
});

/**
 * Initialize desktop tab functionality
 */
function initDesktopTabs() {
  const tabButtons = document.querySelectorAll('.tab-button');
  const tabContents = document.querySelectorAll('.desktop-tab-section .tab-content');
  
  tabButtons.forEach(button => {
    button.addEventListener('click', function() {
      const tabId = this.getAttribute('data-tab-id');
      
      // Remove active state from all tabs
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));
      
      // Add active state to clicked tab
      this.classList.add('active');
      const targetContent = document.getElementById('tab-' + tabId);
      if (targetContent) {
        targetContent.classList.add('active');
        
        // Update swiper for the new tab
        const swiper = targetContent.querySelector('.product-swiper');
        if (swiper && swiperInstances[tabId]) {
          swiperInstances[tabId].update();
          swiperInstances[tabId].slideTo(0, 0); // Reset to first slide
        }
      }
    });
  });
}

/**
 * Initialize Swiper sliders for each tab
 */
/**
 * Оновлена функція ініціалізації Swiper слайдерів
 */
function initSwiperSliders() {
  const swiperContainers = document.querySelectorAll('.product-swiper');
  
  swiperContainers.forEach((container, index) => {
    const tabContent = container.closest('.tab-content');
    const tabId = tabContent ? tabContent.id.replace('tab-', '') : index;
    
    // Знаходимо стрілочки в батьківському tab-content
    const prevButton = tabContent.querySelector('.swiper-button-prev');
    const nextButton = tabContent.querySelector('.swiper-button-next');
    
    swiperInstances[tabId] = new Swiper(container, {
      slidesPerView: 3,
      spaceBetween: 32,
      centeredSlides: false,
      loop: false,
      speed: 400,
      slidesPerGroup: 1,
      
      // Responsive breakpoints
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
        1440: {
          slidesPerView: 3,
          spaceBetween: 32,
        }
      },
      
      // Navigation arrows
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      
      // Callbacks
      on: {
        init: function() {
          updateNavigationState(this);
        },
        slideChange: function() {
          updateNavigationState(this);
        },
        reachEnd: function() {
          updateNavigationState(this);
        },
        reachBeginning: function() {
          updateNavigationState(this);
        }
      }
    });
  });
}

/**
 * Update navigation arrow states
 */
function updateNavigationState(swiper) {
  const nextBtn = swiper.navigation.nextEl;
  const prevBtn = swiper.navigation.prevEl;
  
  if (nextBtn) {
    if (swiper.isEnd) {
      nextBtn.style.display = 'none';
    } else {
      nextBtn.style.display = 'flex';
    }
  }
  
  if (prevBtn) {
    if (swiper.isBeginning) {
      prevBtn.style.display = 'none';
    } else {
      prevBtn.style.display = 'flex';
    }
  }
}

/**
 * Initialize mobile tab functionality
 */
function initMobileTabs() {
  const mobileTabButtons = document.querySelectorAll('.mobile-tab-button');
  const mobileTabContents = document.querySelectorAll('.mobile-tab-content');
  const tabSlider = document.getElementById('mobile-tabs-slider');
  let currentTabIndex = 0;
  
  if (mobileTabButtons.length === 0) return;
  
  // Tab switching functionality
  mobileTabButtons.forEach((button, index) => {
    button.addEventListener('click', function() {
      const tabId = this.getAttribute('data-mobile-tab-id');
      
      // Update active states
      mobileTabButtons.forEach(btn => btn.classList.remove('active'));
      mobileTabContents.forEach(content => content.classList.remove('active'));
      
      this.classList.add('active');
      const targetContent = document.getElementById('mobile-tab-' + tabId);
      
      if (targetContent) {
        targetContent.classList.add('active');
      }
      
      currentTabIndex = index;
      centerCurrentTab();
    });
  });
  
  // Center current tab in view
  function centerCurrentTab() {
    const activeTab = mobileTabButtons[currentTabIndex];
    if (activeTab && tabSlider) {
      tabSlider.scrollTo({
        left: activeTab.offsetLeft - (tabSlider.offsetWidth / 2) + (activeTab.offsetWidth / 2),
        behavior: 'smooth'
      });
    }
  }
  
  // Touch/swipe functionality for tabs
  let touchStartX = 0;
  let touchEndX = 0;
  
  if (tabSlider) {
    tabSlider.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, false);
    
    tabSlider.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      handleTabSwipe();
    }, false);
  }
  
  function handleTabSwipe() {
    const minSwipeDistance = 50;
    
    if (touchEndX < touchStartX - minSwipeDistance) {
      // Swipe left - next tab
      if (currentTabIndex < mobileTabButtons.length - 1) {
        currentTabIndex++;
        mobileTabButtons[currentTabIndex].click();
      }
    }
    
    if (touchEndX > touchStartX + minSwipeDistance) {
      // Swipe right - previous tab
      if (currentTabIndex > 0) {
        currentTabIndex--;
        mobileTabButtons[currentTabIndex].click();
      }
    }
  }
  
  // Initialize first tab
  if (mobileTabButtons[0]) {
    setTimeout(() => {
      mobileTabButtons[0].click();
    }, 100);
  }
}

/**
 * Initialize mobile products functionality
 */
function initMobileProducts() {
  const productSliders = document.querySelectorAll('.mobile-product-slider');
  
  productSliders.forEach(slider => {
    const container = slider.querySelector('.mobile-products-container');
    
    if (!container) return;
    
    // Touch/swipe functionality for products
    let productTouchStartX = 0;
    let productTouchEndX = 0;
    
    container.addEventListener('touchstart', function(e) {
      productTouchStartX = e.changedTouches[0].screenX;
    }, false);
    
    container.addEventListener('touchend', function(e) {
      productTouchEndX = e.changedTouches[0].screenX;
      handleProductSwipe();
    }, false);
    
    function handleProductSwipe() {
      const minSwipeDistance = 50;
      const cardWidth = container.querySelector('.mobile-product-card')?.offsetWidth + 20 || 300;
      
      if (productTouchEndX < productTouchStartX - minSwipeDistance) {
        // Swipe left - scroll right
        container.scrollBy({
          left: cardWidth,
          behavior: 'smooth'
        });
      }
      
      if (productTouchEndX > productTouchStartX + minSwipeDistance) {
        // Swipe right - scroll left
        container.scrollBy({
          left: -cardWidth,
          behavior: 'smooth'
        });
      }
    }
  });
}

/**
 * Initialize variant swatches functionality
 */
function initVariantSwatches() {
  const swatchContainers = document.querySelectorAll('.variant-swatches');
  
  swatchContainers.forEach(container => {
    const productCard = container.closest('.product-card');
    const productLink = productCard.querySelector('.product-card-link');
    const productUrl = productLink ? productLink.getAttribute('href') : '';
    const swatches = container.querySelectorAll('.variant-swatch');
    
    swatches.forEach(swatch => {
      swatch.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Remove active state from all swatches in this container
        swatches.forEach(s => s.classList.remove('is-selected'));
        // Add active state to clicked swatch
        this.classList.add('is-selected');
        
        const variantId = this.getAttribute('data-variant-id');
        const variantImage = this.getAttribute('data-variant-image');
        const variantPrice = this.getAttribute('data-variant-price');
        const isAvailable = this.getAttribute('data-variant-available') !== 'false';
        
        if (!isAvailable) {
          showVariantUnavailableMessage('This variant');
          return;
        }
        
        // Update product image if variant has one
        if (variantImage) {
          const productImage = productCard.querySelector('.product-image');
          if (productImage) {
            productImage.src = variantImage;
          }
        }
        
        // Update product price if variant has different price
        if (variantPrice) {
          const priceElement = productCard.querySelector('.product-price');
          if (priceElement) {
            priceElement.textContent = '$' + (variantPrice / 100).toFixed(2);
          }
        }
        
        if (variantId && productUrl) {
          const targetUrl = buildVariantUrl(productUrl, variantId);
          // Optional: Navigate to variant URL
          // window.location.href = targetUrl;
        }
      });
      
      swatch.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          this.click();
        }
      });
    });
  });
}

/**
 * Initialize mobile variant swatches functionality
 */
function initMobileVariantSwatches() {
  const mobileSwatchContainers = document.querySelectorAll('.mobile-variant-swatches');
  
  mobileSwatchContainers.forEach(container => {
    const productCard = container.closest('.mobile-product-card');
    const productLink = productCard.querySelector('.mobile-product-link');
    const productUrl = productLink ? productLink.getAttribute('href') : '';
    const swatches = container.querySelectorAll('.mobile-variant-swatch');
    
    swatches.forEach(swatch => {
      swatch.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Remove active state from all swatches in this container
        swatches.forEach(s => s.classList.remove('is-selected'));
        // Add active state to clicked swatch
        this.classList.add('is-selected');
        
        const variantId = this.getAttribute('data-variant-id');
        const isAvailable = this.getAttribute('data-variant-available') !== 'false';
        
        if (!isAvailable) {
          showVariantUnavailableMessage('This variant');
          return;
        }
        
        if (variantId && productUrl) {
          const targetUrl = buildVariantUrl(productUrl, variantId);
          window.location.href = targetUrl;
        }
      });
      
      swatch.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          this.click();
        }
      });
    });
  });
}

/**
 * Build URL with variant parameter
 */
function buildVariantUrl(productUrl, variantId) {
  let cleanUrl = productUrl.split('?')[0].split('#')[0];
  const separator = cleanUrl.includes('?') ? '&' : '?';
  return `${cleanUrl}${separator}variant=${variantId}`;
}

/**
 * Show variant unavailable message
 */
function showVariantUnavailableMessage(variantName) {
  const message = document.createElement('div');
  message.className = 'variant-unavailable-message';
  message.textContent = `${variantName} is currently unavailable`;
  message.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: #ff4444;
    color: white;
    padding: 12px 16px;
    border-radius: 4px;
    z-index: 9999;
    font-size: 14px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  `;
  
  document.body.appendChild(message);
  
  setTimeout(() => {
    if (message.parentNode) {
      message.parentNode.removeChild(message);
    }
  }, 3000);
}

/**
 * Handle window resize to update Swiper instances
 */
window.addEventListener('resize', function() {
  Object.values(swiperInstances).forEach(swiper => {
    if (swiper && swiper.update) {
      swiper.update();
    }
  });
});
